import classNames from "classnames";
import { formatWithLocale } from "@hudson/ui/lib/date_fns_locale";

function PickupDate({
  className = "",
  date,
}: {
  className?: string;
  date?: string;
}): JSX.Element | null {
  if (!date) return null;
  return <div className={classNames(className)}>{formatWithLocale(date, "EEEE PP")}</div>;
}

export default PickupDate;
